const cities = {
  enCities: [
    'Buqayq',
    'Alahsa',
    'Alasyah',
    'Al Aflaj',
    'Al Bahah',
    'Al Badai',
    'Al Bukayriyah',
    'Al Jubayl',
    'Al Jumum',
    'Al Jawf',
    'Al Harth',
    'Al Hariq',
    'Al Hinakiyah',
    'Al Khubar',
    'Al Kharj',
    'Al Kharkhir',
    'Al Khurmah',
    'Al Khafji',
    'Ad Dair',
    'Ad Diriyah',
    'Ad Dammam',
    'Ad Duwadimi',
    'Ar Rass',
    'Riyadh',
    'Ar Rayth',
    'Az Zulfi',
    'As Sulayyil',
    'Ash Shimasiyah',
    'Ash Shinan',
    'Taif',
    'Al Ardah',
    'Al Aqiq',
    'Al Ila',
    'Al Aydabi',
    'Al Ghat',
    'Al Ghazalah',
    'Al Qura',
    'Al Qurayyat',
    'Al Qatif',
    'Al Qunfudhah',
    'Al QuwayIyah',
    'Al Qayyas',
    'Al Kamil',
    'Al Lith',
    'Al Majardah',
    'Al Majmaah',
    'Al Mukhwah',
    'Al MadInah Al Munawwarah',
    'Al Midhnab',
    'Al Muzahimiyah',
    'Al Mandaq',
    'Al Mahd',
    'An Nabhaniyah',
    'An NuayrIyah',
    'An Namas',
    'Al Wajh',
    'Abha',
    'Abu Arish',
    'Ahad Al Masarihah',
    'Ahad Rufaydah',
    'Umluj',
    'BiljurashI',
    'Badr',
    'Badr Al Janub',
    'Buraydah',
    'Baqaa',
    'Balqarn',
    'Baysh',
    'Bishah',
    'Tabuk',
    'Tathlith',
    'Turubah',
    'Tayma',
    'Thadiq',
    'Thar',
    'Jazan',
    'Jeddah',
    'Hail',
    'Hubuna',
    'Huraymila',
    'Hafar Al Batin',
    'Haqil',
    'Hawtat Bani Tamim',
    'Khabash',
    'Khulays',
    'Khamis Mushayt',
    'Khaybar',
    'Dawmat Al Jandal',
    'Rabigh',
    'Ras Tannurah',
    'Rijal Alma',
    'Rafha',
    'Rumah',
    'Ranyah',
    'Riyad Al Khabra',
    'Sarat Abidah',
    'Sakaka',
    'Sharurah',
    'Shaqra',
    'Samtah',
    'Sabya',
    'Duba',
    'Dirma',
    'Damad',
    'Turayf',
    'Zahran Al Janub',
    'Arar',
    'Afif',
    'Unayzah',
    'Uyun Al Jiwa',
    'Farasan',
    'Qaryah Al Ulya',
    'Qilwah',
    'Muhayil',
    'Makkah Al Mukarramah',
    'Najran',
    'WadI Ad Dawasir',
    'Yadamah',
    'Yanbu',
    'Other'
  ],

  arCities: [
    'ابقيق',
    'الأحساء',
    'الأسياح',
    'الأفلاج',
    'الباحة',
    'البدائع',
    'البكيرية',
    'الجبيل',
    'الجموم',
    'الجوف',
    'الحرث',
    'الحريق',
    'الحناكية',
    'الخبر',
    'الخرج',
    'الخرخير',
    'الخرمة',
    'الخفجي',
    'الدائر',
    'الدرعية',
    'الدمام',
    'الدوادمي',
    'الرس',
    'الرياض',
    'الريث',
    'الزلفي',
    'السليل',
    'الشماسية',
    'الشنان',
    'الطائف',
    'العارضة',
    'العقيق',
    'العلا',
    'العيدابي',
    'الغاط',
    'الغزالة',
    'القرى',
    'القريات',
    'القطيف',
    'القنفذة',
    'القويعية',
    'القياس',
    'الكامل',
    'الليث',
    'المجاردة',
    'المجمعة',
    'المخواة',
    'المدينة المنورة',
    'المذنب',
    'المزاحمية',
    'المندق',
    'المهد',
    'النبهانية',
    'النعيرية',
    'النماص',
    'الوجه',
    'أبـها',
    'أبو عريش',
    'أحد المسارحة',
    'أحد رفيدة',
    'أملج',
    'بالجرشي',
    'بدر',
    'بدر الجنوب',
    'بريدة',
    'بقعاء',
    'بلقرن',
    'بيش',
    'بيشة',
    'تبوك',
    'تثليث',
    'تربة',
    'تيماء',
    'ثادق',
    'ثار',
    'جازان',
    'جدة',
    'حائل',
    'حبونا',
    'حريملاء',
    'حفر الباطن',
    'حقل',
    'حوطة بني تميم',
    'خباش',
    'خليص',
    'خميس مشيط',
    'خيبر',
    'دومة الجندل',
    'رابغ',
    'رأس تنورة',
    'رجال ألمع',
    'رفحاء',
    'رماح',
    'رنية',
    'رياض الخبراء',
    'سراة عبيدة',
    'سكاكا',
    'شرورة',
    'شقراء',
    'صامطة',
    'صبياء',
    'ضباء',
    'ضرماء',
    'ضمد',
    'طريف',
    'ظهران الجنوب',
    'عرعر',
    'عفيف',
    'عنيزة',
    'عيون الجواء',
    'فرسان',
    'قرية العليا',
    'قلوة',
    'محايل',
    'مكة المكرمة',
    'نجران',
    'وادي الدواسر',
    'يدمة',
    'ينبع',
    'أخرى'
  ]
};

export default cities;
